import React from 'react'
import { useTranslation } from 'react-i18next'
import {
	ContentCheckProofStatus,
	ReportStatus,
	TenantType
} from 'generated/types'
import { ActionsWrapper, ActionButton } from '../styles'
import {
	ReportUserMessageModal,
	ContentCheckUserMessageModal
} from '../UserMessageModal'

type Tenant = TenantType

/**
 * Base shape for content rows in the table. Both report and content-check rows extend it.
 */
type BaseRow = {
	id: string
	selectedSystemId?: string
	tenant?: Tenant | null
}

type ReportRow = BaseRow & { __type: 'report'; status: ReportStatus }
type ContentCheckRow = BaseRow & {
	__type: 'contentCheck'
	status: ContentCheckProofStatus
}
export type ActionsCellRow = ReportRow | ContentCheckRow

/**
 * Action cell props: receives the entire row to decide which modal to open.
 */
export type ActionsCellProps = {
	row: ActionsCellRow
}

/**
 * Renders the "write message" action and the appropriate modal (report/content check),
 * depending on the row type. The modal is only shown if `selectedSystemId` and `tenant` exist.
 */
const ActionsCell: React.FC<ActionsCellProps> = ({ row }) => {
	const [t] = useTranslation()
	const [open, setOpen] = React.useState(false)
	const openModal = () => setOpen(true)
	const closeModal = () => setOpen(false)

	return (
		<ActionsWrapper>
			<ActionButton onClick={openModal}>
				{t('approval.approvalList.reportCard.writeMessage')}
			</ActionButton>
			{row.__type === 'report'
				? row.selectedSystemId &&
					row.tenant && (
						<ReportUserMessageModal
							reportId={row.id}
							systemId={row.selectedSystemId}
							tenant={row.tenant}
							open={open}
							closeMessageModal={closeModal}
							status={row.status}
						/>
					)
				: row.selectedSystemId &&
					row.tenant && (
						<ContentCheckUserMessageModal
							contentCheckId={row.id}
							systemId={row.selectedSystemId}
							tenant={row.tenant}
							open={open}
							closeMessageModal={closeModal}
							status={row.status}
						/>
					)}
		</ActionsWrapper>
	)
}

export default ActionsCell
